<wa-card>
  <wa-slider (valueChange)="updateValue()" [ngModel]="sliderValue()" (ngModelChange)="sliderValue.set($event)"
             [hint]="description()" [label]="name() | formatKey" [max]="100"
             [min]="0" [step]="5" withTooltip></wa-slider>
</wa-card>
